import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GerenciarPermissoesService {

  constructor( private readonly http: HttpClient ) { }

  public getPermissoes(idContato) {
    return this.http.get(`/apiconnect/core/permissions/${idContato}/users`);
  }

  public getContato(idContato) {
    return this.http.get(`/apiconnect/orders/contacts/data/${idContato}/contacts`);
  }

  public getEnderecos(idEmpresa) {
    return this.http.get(`/apiconnect/importation/billing-address/${idEmpresa}/companies`);
  }

  public postpermissoes(obj) {
    return this.http.post(`/apiconnect/core/permissions/users` , obj);
  }
}
